import * as React from "react";

import {ChatUtils} from "@atg-tillsammans-shared/chat-utils";
import {PreservedText, Typography} from "@atg-tillsammans-shared/ui";
import browserHistory from "atg-history";

import ChatAvatar from "../TeamChatAvatar";

import * as styles from "./ChatNotification.styles";

import type {Author} from "@atg-tillsammans-shared/chat-types";

export type Props = {
    text: string;
    title: string;
    author?: Author;
    link?: string;
};

function ChatNotification({text, title, author, link}: Props) {
    return (
        <div
            data-test-id="notification-chat-root"
            css={styles.container}
            onClick={link ? () => browserHistory.push(link) : undefined}
        >
            <div css={styles.aside}>
                {author && (
                    <ChatAvatar
                        imageUrl={author.imageUrl ?? null}
                        alt={ChatUtils.getDisplayName(author)}
                        online
                        showTooltip
                    />
                )}
            </div>
            <div css={styles.main}>
                {author && (
                    <Typography
                        variant="title.sm"
                        color="inverted.default"
                        testId="notification-chat-title"
                        as="span"
                    >
                        {title}
                    </Typography>
                )}
                <PreservedText
                    color="inverted.default"
                    testId="notification-chat-text"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    css={styles.message}
                >
                    {text}
                </PreservedText>
            </div>
        </div>
    );
}

export default ChatNotification;
